import React from 'react';
import IndexSections from '../../components/PTGC/index/index';  // ✅ Fix import

const IndexPage = () => {
  return (
    <>
      <IndexSections />  {/* ✅ Fix component usage */}
    </>
  );
};

export default IndexPage;